import { useEffect, useState } from "react";

export function useDebounce(value: any, timeout: number, callback: () => void) {
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    const clearTimer = () => {
        if (timer) {
            clearTimeout(timer);
        }
    };

    useEffect(() => {
        clearTimer(); // Clear the timer on each keystroke
        if (value) {
            const newTimer = setTimeout(() => {
                callback(); // Call the callback when the timeout is reached
            }, timeout);
            setTimer(newTimer); // Set the new timer
        }

        return () => {
            clearTimer(); // Clean up the timer on unmount
        };
    }, [value]); // Dependency array to track value changes

    return clearTimer; // Optional: return clearTimer if you need it elsewhere
}





// import { useEffect, useState } from "react";

// export function useDebounce(value: any, delay: number, callback: () => void) {
//     useEffect(() => {
//         // Set a timer to invoke the callback after the specified delay
//         const handler = setTimeout(() => {
//             callback();
//         }, delay);

//         // Cleanup function to clear the timer if the value changes or component unmounts
//         return () => {
//             clearTimeout(handler);
//         };
//     }, [value, delay, callback]); // Only reset the timer if value, delay, or callback changes
// }
